import AnalyticsDashboardAppConfig from './dashboards/analytics/AnalyticsDashboardAppConfig';
import DemoAppConfig from './demo/DemoAppConfig';
import HomeAppConfig from './home/HomeAppConfig';
import ListCategoryAppConfig from './listCategory/ListCategoryAppConfig';

const appsConfigs = [HomeAppConfig, AnalyticsDashboardAppConfig, DemoAppConfig, ListCategoryAppConfig];

export default appsConfigs;
